export default "__VITE_ASSET__4190365d__"